import Channels from "../base/channels";
import * as Helpers from "../common/Helpers";
import axios from "axios";
import gsap from "gsap";

export default class FilterActions {
  constructor(view) {
    this.DOM = {};
    this.DOM.view = view;
    // DOM
    // console.log(this.DOM.filterView);
    // if (typeof this.DOM.filterView == "undefined") return false;
    this.DOM.filterView = this.DOM.view.querySelector(".jsFilter--view");
    this.DOM.triggersFilters =
      this.DOM.filterView.querySelectorAll(".jsFilterTrigger");
    this.DOM.filtersDate =
      this.DOM.filterView.querySelectorAll(".jsFilterDate");
    this.DOM.triggersPagination =
      this.DOM.view.querySelectorAll(".jsPagination");
    this.DOM.btnClear = this.DOM.filterView.querySelector(".jsFilterReset");
    this.DOM.filterReceptor = this.DOM.view.querySelector(
      ".jsFilter--receptor"
    );
    // Objects
    this.XHR = {
      action: this.DOM.filterView.getAttribute("data-xhr"),
      template: this.DOM.filterView.getAttribute("data-template"),
      postID: this.DOM.filterView.getAttribute("data-postid"),
    };
    this.RENDER_P;
    this.parentPageID = this.DOM.view.getAttribute("data-parent-page");
    this.paramsFilters = {};
    this.paginationFilters = {};
    // Fns
    this.onHashChange = this.request.bind(this);
    // Flags
    this.ENABLED = true;
  }

  destroy() {
    if (typeof this.DOM.filterView != "undefined") {
      Channels.removeListener("window::hashchange", this.onHashChange);
    }
  }

  events() {
    for (let i = 0; i < this.DOM.triggersFilters.length; i++) {
      const $filter = this.DOM.triggersFilters[i];
      $filter.addEventListener("click", () => {
        this.toggle($filter);
      });
    }

    if (this.DOM.btnClear != null) {
      this.DOM.btnClear.addEventListener("click", () => {
        this.resetToAll();
      });
    }

    Channels.on("window::hashchange", this.onHashChange);
  }

  eventsPagination() {
    this.DOM.triggersPagination =
      this.DOM.view.querySelectorAll(".jsPagination");

    for (let i = 0; i < this.DOM.triggersPagination.length; i++) {
      const $btn = this.DOM.triggersPagination[i];
      $btn.addEventListener("click", (e) => {
        this.paginationFilters.number = $btn.getAttribute("data-page");
        this.request();
        e.preventDefault();
        e.stopPropagation();
      });
    }
  }

  prepareDatas(trigger) {
    this.paramsFilters = [];
    for (let i = 0; i < this.DOM.triggersFilters.length; i++) {
      const $filter = this.DOM.triggersFilters[i];
      const term = $filter.getAttribute("data-term");

      const value = $filter.getAttribute("data-value");
      const text = $filter.querySelector(".text").innerHTML;
      if (typeof this.paramsFilters[term] == "undefined") {
        this.paramsFilters[term] = [];
      }
      if ($filter.classList.contains("is--enabled")) {
        this.paramsFilters[term].push(value);
      }
    }
    if (
      this.paramsFilters.category == "" &&
      this.paramsFilters.year == "" &&
      this.paramsFilters.month == ""
    ) {
      this.resetToAll();
    } else {
      this.sendDatasToUrl();
    }
  }

  removeSelected(btn, filter) {
    btn.parentElement.removeChild(btn);
    filter.classList.remove("is--enabled");
    this.fxLeaving(filter);
    this.prepareDatas();
  }

  fxLeaving(el) {
    el.classList.add("is--leaving");
    setTimeout(() => {
      el.classList.remove("is--leaving");
    }, 410);
  }

  renderFilterShortcuts() {
    const paramsToSend = Helpers.parseHashUrl();
    // if(this.DOM.filtersDate.length > 0) {
    //   for(let filter of this.DOM.filtersDate) {
    //     filter.classList.remove('is--enabled')
    //   }
    // }
    for (let param in paramsToSend) {
      const valueParam = paramsToSend[param];
      const valueParamToArray = valueParam.split(",");
      for (let i = 0; i < valueParamToArray.length; i++) {
        const getValue = valueParamToArray[i];
        const klass = `.${param}-${getValue}`;
        if (this.DOM.filterView.querySelector(klass) != null) {
          if (param == "category" || param == "year" || param == "month") {
            const $filter = this.DOM.filterView.querySelector(klass);
            const term = $filter.getAttribute("data-term");
            const value = $filter.getAttribute("data-value");
            const text = $filter.querySelector(".text").innerHTML;
            $filter.classList.add("is--enabled");
          }
        }
      }
    }
  }

  sendDatasToUrl() {
    const query = Helpers.jsonToQueryParams(this.paramsFilters);
    window.location.hash = query;
  }

  request() {
    if (this.ENABLED) {
      const paramsToSend = Helpers.parseHashUrl();
      this.renderFilterShortcuts();
      if (typeof paramsToSend.reset != "undefined" && paramsToSend.reset == 1) {
        this.resetTriggers();
      } else {
        if (typeof paramsToSend.category != "undefined") {
          if (this.DOM.btnClear != null) {
            this.DOM.btnClear.classList.remove("is--enabled");
          }
        }
      }

      const tl = gsap.timeline();
      tl.add([
        gsap.to(this.DOM.filterReceptor, {
          autoAlpha: 0,
          ease: "cubic.out",
          duration: 0.2,
        }),
      ]);
      tl.add(() => {
        // Request
        axios
          .get(config.XHR_URL, {
            params: {
              wpml_lang: config.langShort,
              lang: config.langShort,
              action: this.XHR.action,
              template: this.XHR.template,
              filters: paramsToSend,
              postID: this.XHR.postID,
              parentID: this.parentPageID,
              pagination: this.paginationFilters,
            },
          })
          .then((response) => {
            this.DOM.filterReceptor.classList.remove("is--loading");
            this.DOM.filterReceptor.innerHTML = response.data;
            gsap.set(this.DOM.filterReceptor, { autoAlpha: 1, delay: 1 });
            Channels.emit("grid::update");
            this.eventsPagination();
          });
      });
    }
  }

  resetTriggers() {
    for (let i = 0; i < this.DOM.triggersFilters.length; i++) {
      const $filter = this.DOM.triggersFilters[i];
      $filter.classList.remove("is--enabled");
      this.fxLeaving($filter);
    }
  }

  resetToAll() {
    if (this.DOM.btnClear != null) {
      this.DOM.btnClear.classList.add("is--enabled");
    }
    window.location.hash = "reset=1";
  }

  setup() {
    if (typeof this.DOM.filterView != "undefined") {
      this.events();
      this.eventsPagination();
      if (window.location.hash.length > 0) {
        this.updateByUrl();
      }
    }
  }

  toggle(trigger) {
    //! Reset Pagination
    this.paginationFilters.number = 1;
    //!
    trigger.classList.toggle("is--enabled");
    if (trigger.classList.contains("is--enabled") == false) {
      this.fxLeaving(trigger);
    }
    this.prepareDatas();
  }

  updateByUrl() {
    const paramsToSend = Helpers.parseHashUrl();
    if (
      paramsToSend.category == "" ||
      paramsToSend.year == "" ||
      paramsToSend.month == ""
    ) {
      this.resetToAll();
    } else {
      this.request();
    }
  }
}
